<template>
  <fieldset class="mb-24">
    <div>
      <div class="flex flex-col md:flex-row md:items-center justify-between gap-16 pb-16">
        <div class="min-w-0 flex-1">
          <p class="font-bold">Paid professional experience</p>
          <p class="text-small text-grey-text-subdued mt-4">Babysitter, nanny, teacher, camp counselor, or tutor.</p>
        </div>
        <poppins-counter ref="paidProfessionalCounter" v-model="yearsExperience" label="years" :min="0" :max="50" />
      </div>

      <horizontal-divider />

      <div class="flex flex-col md:flex-row md:items-center justify-between gap-16 pt-16">
        <div class="min-w-0 flex-1">
          <p class="font-bold">Informal/family experience</p>
          <p class="text-small text-grey-text-subdued mt-4">Relatives, siblings, or neighbor help.</p>
        </div>
        <poppins-counter ref="informalFamilyCounter" v-model="informalYearsExperience" label="years" :min="0" :max="50" />
      </div>
    </div>
  </fieldset>
</template>

<script lang="ts">
import { mapActions, mapGetters } from 'vuex';

// Components
import PoppinsCounter from '@/components/counter/PoppinsCounter.vue';
import HorizontalDivider from '@/components/divider/HorizontalDivider.vue';

// Helpers
import focusOnElement, { FocusOnElementOptions } from '@/helpers/focusHelper';

export default {
  name: 'YearsExperienceStep',
  components: {
    PoppinsCounter,
    HorizontalDivider,
  },
  computed: {
    ...mapGetters(['getFormField']),
    yearsExperience: {
      get() {
        if (this.getFormField('yearsExperience') === null) this.updateForm({ key: 'yearsExperience', value: 0 });
        return this.getFormField('yearsExperience') || 0;
      },
      set(newValue) {
        return this.updateForm({ key: 'yearsExperience', value: newValue });
      },
    },
    informalYearsExperience: {
      get() {
        if (this.getFormField('informalYearsExperience') === null) {
          this.updateForm({ key: 'informalYearsExperience', value: 0 });
        }
        return this.getFormField('informalYearsExperience') || 0;
      },
      set(newValue) {
        return this.updateForm({ key: 'informalYearsExperience', value: newValue });
      },
    },
  },
  methods: {
    ...mapActions(['updateForm']),
    validate() {
      return (
        this.yearsExperience >= 0 &&
        this.yearsExperience <= 50 &&
        this.informalYearsExperience >= 0 &&
        this.informalYearsExperience <= 50
      );
    },
    focusElement(options: FocusOnElementOptions = {}) {
      const counterRef = this.yearsExperience < 1 ? this.$refs.paidProfessionalCounter : this.$refs.informalFamilyCounter;
      const addButton = (counterRef as InstanceType<typeof PoppinsCounter>)?.$refs?.addButton as HTMLButtonElement | undefined;
      focusOnElement(addButton, options);
    },
  },
};
</script>
